<svelte:options customElement="clw-icon-plus" />

<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
    ><path
        d="M4 8.25a0.75 0.75 0 0 0 0 1.5V8.25ZM9 9.751a0.75 0.75 0 0 0 0 -1.5v1.5Zm0 -1.5a0.75 0.75 0 0 0 0 1.5V8.25Zm5 1.5a0.75 0.75 0 0 0 0 -1.5v1.5ZM9.75 9a0.75 0.75 0 0 0 -1.5 0h1.5Zm-1.5 5a0.75 0.75 0 0 0 1.5 0H8.249Zm0 -5a0.75 0.75 0 0 0 1.5 0H8.249Zm1.5 -5a0.75 0.75 0 0 0 -1.5 0h1.5Zm-5.749 5.749H9V8.249H4v1.5Zm5 0h5V8.249H9v1.5Zm0 -0.75h-0.75v5h1.5V9H9Zm0.75 0V4H8.249V9h1.5Z"
        fill="white"
    /></svg
>
